<template>
  <div class="date-label" v-bind:class="{'active' : isActive}">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: ['text', 'isActive'],
  name: 'DateLabel'
}
</script>

<style>
  .date-label {
    display: flex;
    align-items: center;
    padding: 8px 14px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(52, 64, 84, 0.20);
  }

  .date-label.active {
    color: #101828;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/CalendarComponent/DateLabel.vue